import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'ar'],
  defaultLocale: 'ar',
  localeCookieName: 'lang',
  localePrefix: 'as-needed',
  localeDetection: false,
});
